import React, { useContext, useEffect, useMemo } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { filtrationcontext } from "../../context/Filtercontext";
import Loader from "../Helpers/Loader/Loader";
import { useCheckSessionQuery } from "../../Redux/service/Users/AuthUsers";
import { useSelector } from "react-redux";

export default function AuthLayout() {
	const { loader } = useContext(filtrationcontext);
	const navigate = useNavigate();
	const user = useSelector((state) => state.users.auth);

	const target = useMemo(() => {
		const has = (key) => user?.permissions?.some((p) => p.moduleKey === key);

		return has("DASHBOARD")
			? "/dashboard"
			: has("DASHBOARDQAQC")
				? "/dashboard/qa"
				: has("FSMDASHBOARD")
					? "/dashboard/fsm"
					: has("CONSULTANTDASHBOARD")
						? "/dashboard/consultant"
						: "/setup/account";
	}, [user?.permissions]);

	const { data, isFetching, isLoading } = useCheckSessionQuery(undefined, {
		refetchOnMountOrArgChange: true,
	});

	useEffect(() => {
		if (!isLoading && !isFetching && data?.success) {
			navigate(target, { replace: true });
		}
	}, [data?.success, isLoading, isFetching, navigate, target]);

	if (loader || isLoading || isFetching) {
		return (
			<div className="loader-container" style={{ height: "100vh" }}>
				<Loader />
			</div>
		);
	}

	return <Outlet />;
}
